import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NewPasswordModel } from '../../models/new-password.model';
import { ActivatedRoute, Router } from '@angular/router';
import { UserTokenRequest } from '../../models/user-token-request.model';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../../dialog/message-dialog/message-dialog.component';
import { UserTokenResponse } from '../../models/user-token-response.model';
import { IUserLoginRequest } from '../../models/IUserLoginRequest';
import { Subscription } from 'rxjs';
import { UserTokenService } from '../../services/User-Token.service';
import { AuthService } from '../../services/Auth.service';
import { NotificationsToastService } from '../../../shared/services/Notifications-Toast.service';

@Component({
  selector: 'app-recovery-password',
  templateUrl: './recovery-passwordPage.component.html',
  styleUrls: ['./recovery-passwordPage.component.css']
})
export class RecoveryPasswordPageComponent implements OnInit {

  formChangePassword: FormGroup;
  tokenUrl: any;
  key: string;
  newkey: string;
  accessIsValid: boolean;
  userTokenRequest = {} as UserTokenRequest;
  newPasswordModel = {} as NewPasswordModel;
  userTokenResponse = {} as UserTokenResponse;

  subscription_Login: Subscription;
  suscription_resetPassword: Subscription;

  constructor(private formBuilder: FormBuilder,
    private userTokenService: UserTokenService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private authService: AuthService,
    private notificationsToastService: NotificationsToastService) { }

  ngOnInit() {

    console.log("RecoveryPasswordComponent");
    
    this.getUrlToken();
    this.validateToken();

    this.formChangePassword = this.formBuilder.group({
      newPassword: ["", Validators.required],
      repeatNewPassword: ["", Validators.required],
    });
  }

  ngOnDestroy(): void {
    if (this.suscription_resetPassword) 
      this.suscription_resetPassword.unsubscribe();
    if (this.subscription_Login) 
      this.subscription_Login.unsubscribe();
  }

  changePasword() {
    var password = this.formChangePassword.get('newPassword').value;
    var newPassword = this.formChangePassword.get('repeatNewPassword').value;
    if(password === newPassword){
      this.newPasswordModel.email = this.userTokenResponse.email;
      this.newPasswordModel.newPassword = password;
      this.authService.resetPassword(this.newPasswordModel).subscribe(response=>{
        if(response.isSuccess){
          this.openGenericDialog('Se actualizo correctamente su contraseña. Iniciando sesión.', false);
          this.Login();
        } else{
          this.openGenericDialog('Ocurrio un error al cambiar la contraseña. ' + response.errors, false);
        }
      });
    }
    else{
      this.openGenericDialog('Las contraseñas no coinciden.', false);
    }
  }

  getUrlToken() {
    this.route.params.subscribe(params => {
      this.tokenUrl = encodeURIComponent(params['key']);
    });
  }

  validateToken() {
    this.userTokenRequest.token = this.tokenUrl;
    this.userTokenService.isValidToken(this.userTokenRequest).subscribe(response => {
      this.accessIsValid = response.result.isValid;
      if (!this.accessIsValid) {
          this.openGenericDialog("El enlace seleccionado ya no es valido. Ahora sera redirigido al login.", true);
      } else {
        this.userTokenResponse.email = response.result.email;
        this.userTokenResponse.isValid = response.result.isValid;
      }
    });
  }

  openGenericDialog(mensaje: any, goToLogin:boolean) {
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '450px',
      data: mensaje,
      panelClass: 'dialog-container-custom'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (goToLogin){
        this.router.navigate(["/login"]);
      }
    });
  }

  Login() {
    const usuarioLogin: IUserLoginRequest = {
      email: this.userTokenResponse.email,
      password: this.newPasswordModel.newPassword,
    };
    this.subscription_Login = this.authService.Login(usuarioLogin).subscribe(
      (res) => {
        console.log("arg", res);
        if (res.isSuccess == true) {
          const token = res.result.token;
          localStorage.setItem("userName", res.result.userName);
          console.log("token", token);
          if (token) {
            console.log("**********LOGIN COMPLETE*******");
            localStorage.setItem("token", token);
                localStorage.setItem("user", this.userTokenResponse.email);
            this.router.navigate(["/callback"]);
          }
        } else {
        // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
        }
      },
      (err) => {
        console.log("Error al loggearse", err);
        // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
      }
    );
  }

}
